import { NodeViewWrapper } from '@tiptap/react';
import { ListChecks, Users, ClipboardList, FileText } from 'lucide-react';
import { SECTION_TYPES, type SectionType } from './AutoSectionExtension';

const SECTION_ICONS: Record<SectionType, typeof ListChecks> = {
  'open-tasks': ClipboardList,
  'attendees': Users,
  'action-items': ListChecks,
  'recent-notes': FileText,
};

const SECTION_COLORS: Record<SectionType, string> = {
  'open-tasks': 'var(--color-warning)',
  'attendees': 'var(--color-accent)',
  'action-items': 'var(--color-success)',
  'recent-notes': 'var(--color-text-secondary)',
};

export function AutoSectionView({ node }: { node: any }) {
  const sectionType = (node.attrs.sectionType || 'action-items') as SectionType;
  const meta = SECTION_TYPES.find(s => s.value === sectionType);
  const Icon = SECTION_ICONS[sectionType] ?? ListChecks;
  const color = SECTION_COLORS[sectionType] ?? 'var(--color-accent)';

  return (
    <NodeViewWrapper>
      <div
        className="auto-section-placeholder"
        style={{ '--section-color': color } as React.CSSProperties}
      >
        <Icon size={16} style={{ color }} />
        <div>
          <span className="auto-section-label">{meta?.label ?? sectionType}</span>
          <span className="auto-section-desc">{meta?.description ?? 'Auto-populated on meeting creation'}</span>
        </div>
      </div>
    </NodeViewWrapper>
  );
}
